import React, { useState } from "react";

import styles from "./ButtonToggleTheme.module.css";

const ButtonToggleTheme = function () {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const toggleThemeHandler = function (e) {
    if (!isDarkMode) {
      document.documentElement.setAttribute("theme", "dark");
      localStorage.setItem("theme", "dark");
      setIsDarkMode(!isDarkMode);
      return;
    }
    document.documentElement.setAttribute("theme", "light");
    localStorage.setItem("theme", "light");
    setIsDarkMode(!isDarkMode);
  };

  return (
    <div className={styles.container}>
      <input
        className={styles.checkbox}
        id="checkbox"
        type="checkbox"
        checked={isDarkMode}
        onChange={toggleThemeHandler}
      />
      <label className={styles.lightswitch} htmlFor="checkbox"></label>
    </div>
  );
};

export default ButtonToggleTheme;
